import { useContext, useEffect, useState } from "react";
import { MediaQueryContext } from "../provider/MediaQueryProvider";

export const useMediaQuery = ()=>{
    return useContext(MediaQueryContext)
}